import { useMemo } from "react";

import { useWorkDesk } from "../../../../Workspace/components/hooks";

export function useClientCardIframeSyncOptions({
  mapPathnameForIframeSrc,
  mapPathnameFromChild,
  syncEnabled,
  sessionCommand,
}) {
  const {
    isWorkdeskClientPath,
    parentPathToIframePath,
    iframePathToWorkdeskParentPath,
  } = useWorkDesk();

  const baseSyncOptions = useMemo(() => {
    const hasExplicitMapping = Boolean(
      mapPathnameForIframeSrc || mapPathnameFromChild
    );
    if (hasExplicitMapping) {
      return { mapPathnameForIframeSrc, mapPathnameFromChild };
    }
    if (isWorkdeskClientPath) {
      return {
        mapPathnameForIframeSrc: parentPathToIframePath,
        mapPathnameFromChild: iframePathToWorkdeskParentPath,
      };
    }
    return {};
  }, [
    mapPathnameForIframeSrc,
    mapPathnameFromChild,
    isWorkdeskClientPath,
    parentPathToIframePath,
    iframePathToWorkdeskParentPath,
  ]);

  return useMemo(() => {
    return {
      ...baseSyncOptions,
      ...(typeof syncEnabled === "boolean" ? { syncEnabled } : {}),
      ...(sessionCommand ? { sessionCommand } : {}),
    };
  }, [baseSyncOptions, syncEnabled, sessionCommand]);
}

export default useClientCardIframeSyncOptions;
